import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import detailsReducer from './detailsPage/data/reducer';
import detailsSaga from './detailsPage/data/sagas';
import listReducer from './listPage/data/reducer';
import listSaga from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  detailsPage: detailsReducer,
  listPage: listReducer,
});

const saga = function* () {
  yield all([detailsSaga(), listSaga()]);
};

export { reducer, routes, saga };
